import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  InputAdornment,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { Button } from "../basic/Button";
import { TextField } from "../basic/TextField";
// import "./ProfileInformation.css";
import validateEmail from "../utils/validateEmail";

const theme = createTheme({
  palette: {},
  components: {
    // MuiTextField: {
    //   styleOverrides: {
    //     root: {
    //     },
    //   },
    // },
  },
});


const EmailVerificationBody = (props) => {
  const [state, setState] = useState({
    stage: 1,
    submission: {
      ...props.p?.submission,
    },
  });

  const localP = useRef({});

  const onChangeEmail = (event) => {
    // Scoped only within this function
    const local_p = { submission: {...props.p.submission} };
    const value = event.currentTarget.value;
    local_p.submission = {
      ...local_p.submission,
      email: value,
    };

    // This is scoped to the component
    localP.current.submission = {
      ...localP.current.submission,
      email: value,
    };

    if (validateEmail(value)) {
      local_p.errors = {
        ...local_p.errors,
        email: false,
      };
    } else {
      local_p.errors = {
        ...local_p.errors,
        email: "Enter a valid first email address.",
      };
    }

    setState({
      ...state,
      submission: local_p.submission,
      errors: local_p.errors,
    });
  };

  const onChangeEmailVerificationCode = (event) => {
    const local_p = { submission: {...props.p.submission} };
    const value = event.currentTarget.value;
    console.log("value", value);
    local_p.submission = {
      ...local_p.submission,
      emailVerificationCode: value,
    };

    localP.current.submission = {
      ...localP.current.submission,
      emailVerificationCode: value,
    };

    if (value.length === 6) {
      local_p.errors = {
        ...local_p.errors,
        code: false,
      };
    } else {
      local_p.errors = {
        ...local_p.errors,
        code: "Invalid verification code.",
      };
    }
    setState({
      ...state,
      submission: local_p.submission,
      errors: local_p.errors,
    });
  };

  const nextStep = () => {
    setState({ ...state, stage: state.stage + 1 });
  };

  const resRef = useRef(null);
  useEffect(() => {
    (async () => {
      console.log("p", props.p);
      console.log("state", state);

      if (state.stage === 1) {
        try {
          props?.q?.updateState(props?.globalState);
          const res = await props?.q?.doQuery(
            "setSingleUserField",
            "Verification code sent",
            "An error occured",
            {
              submission: state?.submission,
            },
            props?.p,
            props?.p?.userData?.userId,
            "tempEmail",
            `"${props?.p?.submission?.email}"`
          );

          console.log("res1", res);
        } catch (error) {
          console.log("error", error);
        }
      }
      if (state.stage === 2) {
        try {
          props?.q?.updateState(props?.globalState);
          const res = await props?.q?.doQuery(
            "setSingleUserField",
            "Checking verification code",
            "An error occured",
            {
              submission: state?.submission,
            },
            props?.p,
            props?.p?.userData?.userId,
            "sentEmailVerificationCode",
            `"${localP?.current?.submission?.emailVerificationCode}"`
          );

          resRef.current = {
            ...res.data.updateUser,
          };

          console.log("res", res);
          console.log("resRef", resRef);
          console.log("localP", localP);
          console.log("p", props.p);

          if (
            props?.p?.submission.email !== resRef?.current.tempEmail ||
            res.errors
          ) {
            console.log("COND 1");
            setState({ ...state, stage: 1, verificationCodeError: true });
          } else if (
            props?.p?.submission?.email === resRef?.current.tempEmail &&
            localP?.current?.submission?.emailVerificationCode ===
              resRef?.current.emailVerificationCode
          ) {
            console.log("COND 2");
            setState({ ...state, stage: 3, verificationCodeError: false });
            props.emailChangeCallback(props?.p?.submission?.email);
          } else {
            console.log("COND 3");
            setState({ ...state, stage: 1, verificationCodeError: true });
          }
        } catch (error) {
          // console.log("CATCH 1");
          console.log("error", error);
          setState({ ...state, stage: 1, verificationCodeError: true });
        }
      }
      if (state.stage === 3) {
      }
    })();
  }, [state.stage]);

  return (
    <ThemeProvider theme={theme}>
      {state?.stage === 0 && (
        <Stack px={3} width={300}>
          <Box mb={2}>
            <Typography variant="body1">
              Enter your new email address.
            </Typography>
          </Box>
          <Stack mb={2}>
            <TextField
              required
              onChange={onChangeEmail}
              error={state.errors?.email ? true : false}
              value={state.submission?.email || ""}
              fullWidth={true}
              label="Email"
            />
          </Stack>
          <Button disabled={state.errors?.email} onClick={nextStep}>
            Send Verification Code
          </Button>
        </Stack>
      )}

      {state?.stage === 1 && (
        <Stack px={3} width={300}>
          <Box mb={2}>
            <Typography variant="body1">
              Enter the verification code sent to your new email address. <br />
              <br />
              Check your spam folder if you have not received an authentication
              code within 60 seconds.
            </Typography>
          </Box>
          <Stack mb={2}>
            <TextField
              required
              onChange={onChangeEmailVerificationCode}
              error={state.errors?.code ? true : false}
              value={state.submission?.emailVerificationCode || ""}
              fullWidth={true}
              label="Verification Code"
            />
          </Stack>
          <Button disabled={state?.errors?.code} onClick={nextStep}>
            Confirm Verification Code
          </Button>

          {state.verificationCodeError && (
            <Box mt={2}>
              {/* <Alert severity="danger"> */}
              <Typography>Invalid verification code.</Typography>
              {/* </Alert> */}
            </Box>
          )}
        </Stack>
      )}
      {state?.stage === 2 && (
        <Stack px={3} width={300}>
          <Box mb={2}>
            <Typography variant="body1">
              Checking verification code...
            </Typography>
          </Box>
        </Stack>
      )}

      {state?.stage === 3 && (
        <Stack px={3} width={300}>
          <Box mb={2}>
            <Typography variant="body1">
              Your email has been updated succesfully.
            </Typography>
          </Box>
        </Stack>
      )}
    </ThemeProvider>
  );
};

export default EmailVerificationBody;